import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { NotificationService } from "../../services/notification.service";
import { NotificationDataProvider } from "../../data-provider/notification.dp";

let NotificationListComponent = {
    selector: "vcNotificationList",
    templateUrl:
        "/angular/components/notification/notification-list.component.html",
    bindings: {
        uid: "=",
        changeCampaign: "&",
        back: "&",
    },
    controller: class NotificationLisController {
        // * bindings for typescript compiler *
        public uid: any;
        public changeCampaign: any;
        public back: any;
        // ************************************

        private readonly $window: any;
        private dataProvider: NotificationDataProvider;
        private readonly service: NotificationService;
        private campaignDataProvider: CampaignDataProvider;

        constructor(
            NotificationDataProvider: NotificationDataProvider,
            NotificationService: NotificationService,
            $window: any,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.dataProvider = NotificationDataProvider;
            this.service = NotificationService;
            this.$window = $window;
            this.campaignDataProvider = CampaignDataProvider;
        }

        $onInit() {
            this.dataProvider.setUID(this.uid);
            this.dataProvider.getNotifications();
        }

        notificationAction(notification: any): void {
            if (notification.notificationseen == 0) {
                notification.notificationseen = 1;
                this.dataProvider.unseen -= 1;
                this.service.setSeen(notification).then(() => {
                    this.notificationActionHelper(notification);
                });
            } else {
                this.notificationActionHelper(notification);
            }
        }

        notificationActionHelper(notification: any): void {
            if (
                notification.campaignid &&
                notification.campaignid !=
                    this.campaignDataProvider.activeCampaign.campaignid
            ) {
                this.changeCampaign({
                    campaign: { campaignid: notification.campaignid },
                    redirect: notification.notificationlink,
                });
            } else {
                if (notification.notificationlink)
                    this.$window.location.href = notification.notificationlink;
                else if (notification.notificationtype == "QUERY") {
                    this.$window.location.href = "./#/issues";
                }
            }
        }

        notificationAllSeen(): void {
            this.dataProvider.setAllSeen();
        }
    },
};

angular
    .module("notification", [])
    .component(NotificationListComponent.selector, NotificationListComponent);
